import { t } from 'i18next';
import { ChevronLeft } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/configs/constants';

const PolicyPage: React.FC = () => {
    const navigate = useNavigate();
    const handleBack = () => {
        navigate(ROUTES.login.href);
    };
    return (
        <div className='max-w-3xl max-h-screen mx-auto p-2 bg-white shadow-md font-normal text-sm text-black/80'>
            <div className='bg-white flex content-center items-center h-10'>
                <div className='flex justify-start items-center content-center w-full'>
                    <div
                        className='text-main cursor-pointer flex'
                        onClick={handleBack}
                    >
                        <ChevronLeft className='w-6 h-6' />
                        <p className='mt-[1px]'>{t('text.close')}</p>
                    </div>
                </div>
            </div>
            <div className='p-6 overflow-y-scroll max-h-[calc(100vh-60px)]'>
                <h1 className='text-xl font-bold mb-4 text-center'>サービス利用規約</h1>
                <section className='mb-6'>
                    <h2 className='font-semibold   text-base'>第1条（総則）</h2>
                    <div className='ml-4'>
                        <p>
                            <span>1.</span>
                            <span className='ml-4'>本サービス利用規約（以下「本規約」といいます）は、株式会社Prop Consulting（以下「当社」といいます）が提供する、利用者に文書を送付するアプリケーション（サービス名称：「onlinepost」。以下「本アプリ」といいます）を利用する全ての利用者に適用される利用条件を定めるものです。</span>
                        </p>
                        <p>
                            <span>2.</span>
                            <span className='ml-4'>本アプリは、文書を発行する者（以下「事業者」といいます）が、文書を受け取る者（以下「利用者」といいます）に対して、本アプリを経由して文書を送付するサービスを提供します。</span>
                        </p>
                    </div>
                </section>

                <section className='mb-6'>
                    <h2 className='font-semibold   text-base'>第2条（サービスの提供）</h2>
                    <div className='ml-4'>
                        <p>
                            <span>1.</span>
                            <span className='ml-4'>本アプリは、LINE プラットフォームを利用したウェブアプリケーションであり、利用者が提供する情報に基づき、各種サービスを提供します。</span>
                        </p>
                        <p>
                            <span>2.</span>
                            <span className='ml-4'>本アプリは、予告なくサービス内容を変更または停止する場合があります。</span>
                        </p>
                    </div>
                </section>

                <section className='mb-6'>
                    <h2 className='font-semibold   text-base'>第3条（利用登録）</h2>
                    <div className='ml-4'>
                        <p>
                            <span>1.</span>
                            <span className='ml-4'>利用者は、本アプリを利用するためには、LINEアカウントを使用して登録が必要です。利用者は、LINEアカウントを用いて正確かつ最新の情報を提供するものとします。</span>
                        </p>
                        <p>
                            <span>2.</span>
                            <span className='ml-4'>登録情報に虚偽の内容が含まれている場合、または不正な利用が認められた場合、本アプリは登録を拒否または削除することができます。</span>
                        </p>
                    </div>
                </section>

                <section className='mb-6'>
                    <h2 className='font-semibold   text-base'>第4条（個人情報の取り扱い）</h2>
                    <div className='ml-4'>
                        <p>
                            <span>1.</span>
                            <p className='ml-4'>
                                本アプリは、利用者の個人情報を適切に取り扱います。個人情報の収集、利用、保存については、別途定める「
                                <span onClick={() => window.open('https://www.prop.consulting/privacy-policy', '_black')} className='text-blue-500 underline cursor-pointer'>プライバシーポリシー</span>
                                」に従います。
                            </p>
                        </p>
                        <p>
                            <span>2.</span>
                            <span className='ml-4'>利用者が本アプリを利用することにより、プライバシーポリシーに同意したものとみなされます。</span>
                        </p>
                    </div>
                </section>

                <section className='mb-6'>
                    <h2 className='font-semibold   text-base'>第5条（禁止事項）</h2>
                    利用者は、以下の行為を行ってはならないものとします：
                    <div className='ml-4'>
                        <p>
                            <span>1.</span>
                            <span className='ml-4'>本アプリの運営を妨げる行為、またはサーバーに不正アクセスする行為。</span>
                        </p>
                        <p>
                            <span>2.</span>
                            <span className='ml-4'>他の利用者または第三者の権利を侵害する行為。</span>
                        </p>
                        <p>
                            <span>3.</span>
                            <span className='ml-4'>法令に違反する行為または公序良俗に反する行為。</span>
                        </p>
                        <p>
                            <span>4.</span>
                            <span className='ml-4'>本アプリを不正目的で使用する行為。</span>
                        </p>
                        <p>
                            <span>5.</span>
                            <span className='ml-4'>本アプリのソースコードを逆コンパイル、逆アセンブル、逆エンジニアリングする行為。</span>
                        </p>
                    </div>
                </section>

                <section className='mb-6'>
                    <h2 className='font-semibold   text-base'>第6条（サービスの停止・中断）</h2>
                    <div className='ml-4'>
                        <p>
                            <span>1.</span>
                            <span className='ml-4'>本アプリは、次の場合にサービスを一時的に停止または中断することがあります：</span>
                            <p className='ml-6'>
                                <li>定期的または緊急のメンテナンス。</li>
                                <li>システムの障害や不具合。</li>
                                <li>その他、運営上の必要がある場合。</li>
                            </p>
                        </p>
                        <p>
                            <span>2.</span>
                            <span className='ml-4'>サービスの停止・中断により利用者に生じた損害について、本アプリは一切の責任を負いません。</span>
                        </p>
                    </div>
                </section>

                <section className='mb-6'>
                    <h2 className='font-semibold   text-base'>第7条（免責事項）</h2>
                    <div className='ml-4'>
                        <p>
                            <span>1.</span>
                            <span className='ml-4'>当社は、提供するサービスに関して、明示または暗示の保証を一切行いません。</span>
                        </p>
                        <p>
                            <span>2.</span>
                            <span className='ml-4'>本アプリの利用に起因する一切の損害（データ損失、金銭的損失、その他の損害）について、当社は責任を負いません。</span>
                        </p>
                    </div>
                </section>

                <section className='mb-6'>
                    <h2 className='font-semibold   text-base'>第8条（知的財産権）</h2>
                    <div className='ml-4'>
                        <p>
                            <span>1.</span>
                            <span className='ml-4'>本アプリに関連するすべての知的財産権は、当社または正当な権利を有する第三者に帰属します。</span>
                        </p>
                        <p>
                            <span>2.</span>
                            <span className='ml-4'>利用者は、本アプリに含まれるコンテンツを無断で転載、配布、変更、公開などすることはできません。</span>
                        </p>
                    </div>
                </section>

                <section className='mb-6'>
                    <h2 className='font-semibold   text-base'>第9条（規約の変更）</h2>
                    <div className='ml-4'>
                        <p>
                            <span>1.</span>
                            <span className='ml-4'>当社は、必要に応じて本規約を変更することがあります。変更後の規約は、本アプリ内での通知またはその他の方法で利用者に告知され、告知後に本アプリを利用することで新たな規約に同意したものとみなされます。</span>
                        </p>
                    </div>
                </section>

                <section className='mb-6'>
                    <h2 className='font-semibold   text-base'>第10条（準拠法および管轄裁判所）</h2>
                    <div className='ml-4'>
                        <p>
                            <span>1.</span>
                            <span className='ml-4'>本規約は、日本法に基づいて解釈されます。</span>
                        </p>
                        <p>
                            <span>2.</span>
                            <span className='ml-4'>本アプリに関する紛争が発生した場合、[地域名]の裁判所を専属的合意管轄裁判所とします。</span>
                        </p>
                    </div>
                </section>

                <section className='mb-6'>
                    <h2 className='font-semibold   text-base'>第11条（その他）</h2>
                    <div className='ml-4'>
                        <p>
                            <span>1.</span>
                            <span className='ml-4'>本規約に定めのない事項については、法令その他の規定に従うものとします。</span>
                        </p>
                        <p>
                            <span>2.</span>
                            <span className='ml-4'>利用者が本規約に違反した場合、当社はサービスの利用停止など、必要な措置を講じることがあります。</span>
                        </p>
                    </div>
                </section>

                <footer className='mt-10 text-right'>
                    <p>変更履歴</p>
                    <p className='text-gray-600 text-sm'>2025年4月1日：制定</p>
                </footer>
            </div>

        </div>
    );
};

export default PolicyPage;
